export default {
  'infuse.downloadNow': 'Download Now',
  'infuse.continuePhrase':
    'Trusteer Rapport is not responding.  Do you wish to continue without Rapport?',
  'infuse.cancelPhrase':
    'If you elect to cancel and have questions, please contact customer service.'
};
